import {Label, type LabelColorOptions} from '@primer/react'

import {VALUE_TO_VARIANT} from './value-to-variant'

interface TableBadgeProps {
  value: string
  // Chosen by the hast transform; the bare-value lookup is just a fallback.
  variant?: LabelColorOptions
}

export function TableBadge({value, variant}: TableBadgeProps) {
  const key = value.trim().toLowerCase()
  const resolvedVariant = variant ?? (Object.hasOwn(VALUE_TO_VARIANT, key) ? VALUE_TO_VARIANT[key] : 'default')
  return (
    <Label variant={resolvedVariant} size="small">
      {value}
    </Label>
  )
}
